import { LitElement, css } from "lit-element";
import { html } from "lit-html";
import { styleMap } from "lit-html/directives/style-map";
import { classMap } from "lit-html/directives/class-map";
import "@ui5/webcomponents/dist/Button";
import "bds-tree";
import "./panel/checkbox-list";
import {
  getValueFromListControlData,
  getValueFromTreeControlData,
} from "../lib/util";

/**
 * @property {Array} controlDefs - describes the type, id and other metadata about control
 * @property {Array} controlData - contains user visible data and other values
 * @property {Object} initialState - can be used to set the state of the filter
 * @property {Object} controlValues - stores the currently selected values for each control
 * @property {Boolean} show - display or hide filter component
 * @property {Number} screenSize - current size of the screen
 */
class BdsPropertyFilter extends LitElement {
  static get properties() {
    return {
      controlDefs: {
        type: Array,
      },
      controlData: {
        type: Array,
      },
      initialState: {
        type: Object,
      },
      controlValues: {
        type: Object,
        state: true,
      },
      show: {
        type: Boolean,
        state: true,
      },
      screenSize: {
        type: Number,
      },
    };
  }

  constructor() {
    super();
    this.controlDefs = [];
    this.controlData = [];
    this.initialState = {};
    this.controlValues = {};
  }

  connectedCallback() {
    super.connectedCallback();
    this.initializeValues();
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  initializeValues() {
    this.screenSize = Math.min(window.screen.width, window.innerWidth);
    this.show = this.screenSize >= 640;
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    super.disconnectedCallback();
  }

  getDataFromControlData(controlId, propertyValueId) {
    if (Array.isArray(this.controlData) && this.controlData.length > 0) {
      const control = this.controlData.find(
        (data) => controlId == data.controlDefId
      );
      if (control.propertyData.type === "propertyTreeData") {
        return {
          id: propertyValueId,
          value: getValueFromTreeControlData(propertyValueId),
        };
      }

      if (control.propertyData.type === "propertyListData") {
        return {
          id: propertyValueId,
          value: getValueFromListControlData(propertyValueId, controlId),
        };
      }
    }
  }

  filterStateToControlValues(filterState) {
    let controlValues = {};
    let controlDefIds = Object.keys(filterState);
    if (Array.isArray(controlDefIds) && controlDefIds.length > 0) {
      controlDefIds.forEach((controlDefID) => {
        controlValues[controlDefID] = filterState[controlDefID]
          .split(",")
          .map((propertyValueId) =>
            this.getDataFromControlData(controlDefID, propertyValueId)
          );
      });
      console.log("TEST", controlValues);
      return controlValues;
    }
  }

  handleResize() {
    this.screenSize = window.innerWidth;
  }

  updated(changedProperties) {
    if (changedProperties.has("screenSize")) {
      if (this.screenSize >= 640) {
        this.show = true;
      } else {
        this.show = false;
      }
    }

    if (changedProperties.has("initialState")) {
      let values = this.filterStateToControlValues(this.initialState);
      this.controlValues = values ? values : {};
    }
  }

  handleFilterClick(e) {
    this.handleFilterEvent(e, (target) =>
      this.dispatchFilterEvent("filterClick", target)
    );
  }

  handleFilterChange(e) {
    this.handleFilterEvent(e, (target) =>
      this.dispatchFilterClick("filterChange", target)
    );
  }

  handleFilterEvent(e, filterEventDispatcher) {
    let controlId = Number(e.target.dataset.controlid);
    let controlType = e.target.dataset.controltype || "";
    let data = [];
    if (controlType === "uiControlDefTreeDto") {
      data = e.detail.selectedKeys.map((key) => ({
        id: key,
        value: getValueFromTreeControlData(key),
      }));
    } else {
      data = e.detail.data;
    }
    let target = { id: controlId, type: controlType, data: data };
    this.updateControlValues(controlId, data);
    filterEventDispatcher(target);
  }

  dispatchFilterEvent(eventName, target) {
    let options = {
      detail: {
        lstValues: this.controlValues,
        target: target,
      },
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent(eventName, options));
  }

  // handleFilterClick(e) {
  //   let controlId = Number(e.target.dataset.controlid);
  //   let controlType = e.target.dataset.controltype || "";
  //   let data = [];
  //   if (controlType === "uiControlDefTreeDto") {
  //     data = e.detail.selectedKeys.map((key) => ({ id: key, value: key }));
  //   } else {
  //     data = e.detail.data;
  //   }
  //   let target = { id: controlId, type: controlType, data: data };
  //   this.updateControlValues(controlId, data);
  //   this.dispatchFilterClick(target);
  // }

  // handerFliterChange(e) {
  //   let controlId = Number(e.target.dataset.controlid);
  //   let controlType = e.target.dataset.controltype || "";
  //   let data = [];
  //   let target;
  //   if (controlType === "uiControlDefTreeDto") {
  //     data = e.detail.selectedKeys.map((key) => ({ id: key, value: key }));
  //     target = e.detail.selectedKeys;
  //   } else {
  //     data = e.detail.data;
  //     target = data;
  //   }
  //   this.updateControlValues(controlId, data);
  //   this.dispatchFilterChange(target);
  // }

  // Open mobile menu
  handleOpen() {
    this.show = true;
  }

  // Close mobile menu
  handleClose() {
    this.show = false;
  }

  updateControlValues(controlId, data) {
    if (data?.length > 0) {
      this.controlValues[controlId] = [...data];
    } else {
      delete this.controlValues[controlId];
    }
  }

  dispatchFilterClick(target) {
    let options = {
      detail: {
        lstValues: this.controlValues,
        target: target,
      },
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("filterClick", options));
  }

  dispatchFilterChange() {
    let options = {
      detail: {
        lstValues: this.controlValues,
        target: target,
      },
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("filterChange", options));
  }

  // convert controlValues to lstValues format
  controlValuesToLstValues() {
    let keys = Object.keys(this.controlValues).filter(
      (key) => this.controlValues[key].length > 0
    );
    return keys.map((controlId) => ({
      controlDefId: controlId,
      lstValues: this.controlValues[controlId],
    }));
  }

  //Renders component based on control type in  control def
  appendControl(controlDef) {
    let index = this.controlData.findIndex(
      (controlData) => controlData.controlDefId === controlDef.id
    );
    if (this.controlData[index]) {
      let controlData = this.controlData[index];
      switch (controlDef.type) {
        case "uiControlDefListDto":
          return html`<checkbox-list
            data-controlId=${controlDef.id}
            @listClick=${this.handleFilterClick}
            @listChanged=${this.handerFliterChange}
            .boxes=${controlData.propertyData.propertyValues}
            .selectedString=${this.initialState[controlDef.id]}
          >
          </checkbox-list>`;
        case "uiControlDefTreeDto":
          return html`<bds-tree
            .styleConfig=${treeConfig}
            data-controlId=${controlDef.id}
            data-controlType=${controlDef.type}
            @treeClick=${this.handleFilterClick}
            @treeChange=${this.handerFliterChange}
            .nodes=${controlData.propertyData.rootNode.children}
            labelPath="name"
            idPath="propertyValue.id"
            dataPath="propertyValue"
            ?hasUnselect=${true}
            initialNodeId=${this.initialState[controlDef.id]}
          >
          </bds-tree>`;
      }
    }
  }

  //Renders component based on control type in  control def
  appendControlList() {
    if (this.controlDefs.length > 0) {
      return this.controlDefs.map(
        (def) =>
          html`
            <style>
              h2 {
                color: var(--kb-property-filter-text);
              }

              .control__container {
                border-bottom: var(--kb-control-container-border-bottom);
              }

              .control__label {
                font-weight: var(--kb-control-label-fontweight);
                font-size: var(--kb-control-label-fontsize);
                margin: var(--kb-control-label-margin);
                border-bottom: var(--kb-control-label-borderbottom);
                padding: var(--kb-control-label-padding);
              }
            </style>
            <div class="control__container">
              <h2 class="control__label">${def.label}</h2>
              ${this.appendControl(def)}
            </div>
          `
      );
    }
  }

  placeHolderTemplate() {
    return html` <button @click="${this.handleOpen}" class="refine__container">
      <iron-icon icon="vaadin:filter"></iron-icon>
      Refine Results
    </button>`;
  }

  render() {
    const styles = {
      display: this.show ? "block" : "none",
    };
    const containerClasses = {
      "filter-container": this.screenSize >= 640,
      "filter-container--mobile": this.screenSize < 640,
    };
    return html` <link
        rel="stylesheet"
        type="text/css"
        href=${`/kb/config/themes/${theme}/property-filter.css`}
      />
      ${this.placeHolderTemplate()}
      <section class=${classMap(containerClasses)} style=${styleMap(styles)}>
        <iron-icon
          @click=${this.handleClose}
          class="close-btn"
          icon="vaadin:close"
        ></iron-icon>
        <ul
          style="display: flex; flex-direction: column; padding: 0; margin: 0;"
        >
          ${this.appendControlList()}
        </ul>
      </section>`;
  }

  static get styles() {
    return css`
      .filter-container {
        display: none;
        font-size: 14px;
      }

      .refine__container {
        background-color: #e0e0e0;
        display: inline-block;
        width: 100%;
        border: none;
        text-align: left;
        padding: 0.75rem;
      }

      .filter-container--mobile {
        position: fixed;
        overflow-y: auto;
        background-color: white;
        padding: 3rem 2rem;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }

      .close-btn {
        position: absolute;
        right: 2rem;
      }

      bds-tree {
        color: var(--kb-property-filter-text);
        --bds-treenode-active: var(
          --kb-property-filter-treenode-active-color,
          #a6bcc6
        );
        --bds-treenode-arrow-hover: var(
          --kb-property-filter-treenode-arrow-hover,
          #a6bcc6
        );
        --bds-treenode-hover: var(--kb-property-filter-treenode-hover);
        --bds-treenode-vertical-padding: var(--kb-property-filter-treenode-vertical-padding);
      }

      bds-tree::part(node) {
        margin-left: 0;
      }

      @media only screen and (min-width: 640px) {
        /* .filter-container {
          padding: 1rem 0px 0px 2rem;
        } */
        .refine__container {
          display: none;
        }
        .close-btn {
          display: none;
        }
      }
    `;
  }
}

customElements.define("bds-property-filter", BdsPropertyFilter);
